import { Box } from '@mui/material';
import { useParams } from 'react-router-dom';

import DetailsPaper from '../../components/customer/settings/finalReport/details/detailsPaper';

const CustomerFinalReportDetailsPage = () => {
  const { id } = useParams();
  return (
    <Box sx={{ width: '100%', height: '100%' }}>
      <DetailsPaper id={id} />
    </Box>
  );
};

export default CustomerFinalReportDetailsPage;
